import { UserInfoBodyNotValidError } from "@seneca/user-service-client";

export default function errorTranslator(error: Error): string {
  if (error instanceof UserInfoBodyNotValidError) {
    return "The details you entered are incorrect, please try again.";
  }

  return "An unknown error has occurred.";
}
